import React from 'react';
import ScrollableContainer from '../../Componant/Bonus-Ui/Scrollable';

const Scrollable = () => {
  return (
    <div className='page-body'>
      <ScrollableContainer />
    </div>
  );
};

export default Scrollable;
